/**
 * Extract the subdomain from the hostname.
 * @param hostname - The hostname to extract the subdomain from.
 * @returns The subdomain or null if not found.
 */
export function extractSubdomain(hostname: string): string | null {
  const hostWithoutPort = hostname?.split(':')[0]
  const parts = hostWithoutPort?.split('.')

  if (['localhost', 'shalion', 'np'].includes(parts[0])) return null
  return parts[0]
}

/**
 * Get the subdomain from the headers.
 * @param headersList - The headers to get the subdomain from.
 * @returns The subdomain or null if not found.
 */
export function getSubdomainFromHeaders(headersList: Headers): string | null {
  const hostname = headersList.get('host') || headersList.get('x-forwarded-host') || ''
  return extractSubdomain(hostname)
}
